// Only IDs stay in this browser. Public names, photos and ratings are resolved afresh.
export function useCatalogHistory() {
 const user=useUser(),ids=useState<number[]>('catalog-recent',()=>[]);
 const key=()=>`uogorod.catalog.recent.v1.${user.value?.client_id||'guest'}`;
 function load(){try{const data=JSON.parse(localStorage.getItem(key())||'[]');ids.value=Array.isArray(data)?[...new Set(data.filter(id=>Number.isSafeInteger(id)&&id>0))].slice(0,12) as number[]:[];}catch{ids.value=[];}}
 function remember(id:number){if(!Number.isSafeInteger(id)||id<=0)return;load();ids.value=[id,...ids.value.filter(v=>v!==id)].slice(0,12);try{localStorage.setItem(key(),JSON.stringify(ids.value));}catch{}}
 onMounted(load);
 watch(()=>user.value?.client_id,()=>{if(import.meta.client)load();});
 return {ids,remember};
}
